import { Component, Input, ViewChild, ElementRef, Output, EventEmitter, Directive, ViewContainerRef, ComponentFactoryResolver } from "@angular/core";
import { ReportSelectorCompanies } from "../../../company-audit/models/report-selector-companies.model";
import { CompanyFilterSelected } from "../../models/company-filter-selected.model";

@Component({
    selector: 'app-company-filter',
    templateUrl: './company-filter.component.html',
    styleUrls: ['./company-filter.component.css']
})
export class CompanyFilterComponent {
    @Output() exportSelected: EventEmitter<CompanyFilterSelected> = new EventEmitter<CompanyFilterSelected>();
    //@Output() onHide: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Input() companies: ReportSelectorCompanies[];
    @Input() parent: string;
    @Input() level: number;
    levelCompanies: ReportSelectorCompanies[][];
    selectedCompany: string = "0";
    selectedExclude: boolean = false;
    selectedLevel: number = 0;
    selectedPath: string[] = [];
    selectedChildren: ReportSelectorCompanies[][];
    excludeDownstream: boolean[];
    selectedCompanyOutput: CompanyFilterSelected;

    @ViewChild(CompanyFilterComponent, { static: true }) childCompanies: CompanyFilterComponent;

    constructor(
        public viewContainerRef: ViewContainerRef,
        private componentFactoryResolver: ComponentFactoryResolver
    ) {
    }

    ngOnInit() {

    }
    ngOnChanges() {
        if (this.level==0) {
            this.level = 0;
        }
        if (this.companies) {
            this.companies.forEach(x => {
                if (x.treeLevel + 1 > this.selectedPath.length) {
                    this.selectedPath.push("0");
                }
            });
            this.populateLevelCompanies();
        }
    }
    populateLevelCompanies() {
        this.levelCompanies = [];
        this.selectedChildren = [];
        this.excludeDownstream = [];
        for (var i = 0; i < this.selectedPath.length; i++) {
            var l = this.companies.filter(x => x.treeLevel === i);
            this.levelCompanies.push(l);
            var c = [];
            this.selectedChildren.push(c);
            var e = false;
            this.excludeDownstream.push(e);
        }
    }

    selectCompany(level: number, companyId: string, excludeDownstream: boolean) {

        this.selectedLevel = level;
        this.selectedCompany = companyId;
        this.selectedExclude = excludeDownstream;
        this.selectedPath[level] = companyId;
        for (var i = level + 1; i < this.selectedPath.length; i++) {
            this.selectedPath[i] = '0';
        }
        this.selectedChildren[level] = this.companies.filter(x => x.parentId == companyId);
        if (excludeDownstream) {
            this.excludeDownstream[level] = excludeDownstream;
        } else {
            this.excludeDownstream[level-1] = excludeDownstream;
        }
        // form value requires null for all companies, not 0
        if (companyId == "0") {
            companyId = null
        };
        this.selectedCompanyOutput = { companyId: companyId, excludeDownstream: excludeDownstream };
        this.exportSelected.emit(this.selectedCompanyOutput);
    }
}
